// extracted by mini-css-extract-plugin
module.exports = {"main":"RecentBoards_main__3vXyH","container":"RecentBoards_container__oqefq","boards":"RecentBoards_boards__2U1jL"};